export const CORRECT_ANSWER = 'CORRECT_ANSWER';
export const correctAnswer = {
    type: CORRECT_ANSWER
};

export const INCORRECT_ANSWER = 'INCORRECT_ANSWER';
export const incorrectAnswer = {
    type: INCORRECT_ANSWER
};


